// @flow

export default function visionUrl() {
  return '/vision'
}
